// src/pages/JH.js
import React from "react";
import "../App.css";
import PottsboroLogo from "../images/Logo.jpg";

export default function JH() {
  const schedule = [
    { date: "Nov 17", opponent: "Gunter", site: "Pottsboro Middle School", games: "4:30, 5:00, 5:30, 6:30", home: true },
    { date: "Dec 1", opponent: "Howe", site: "Howe Middle School", games: "4:30, 5:00, 5:30, 6:30", home: false },
    { date: "Dec 8", opponent: "S & S", site: "Pottsboro Middle School", games: "4:30, 5:00, 5:30, 6:30", home: true },
    { date: "Dec 15", opponent: "Bells", site: "Bells", games: "4:30, 5:00, 5:30, 6:30", home: false },
    { date: "Jan 8", opponent: "Blue Ridge", site: "Pottsboro Middle School", games: "4:30, 5:30, 6:30, 7:30", home: true },
    { date: "Jan 10", opponent: "Van Alstyne Tournament", site: "Van Alstyne", games: "TBD", home: false },
    { date: "Jan 15", opponent: "Leonard", site: "Leonard Junior High", games: "4:30, 5:00, 5:30, 6:30", home: false },
    { date: "Jan 22", opponent: "Bonham", site: "Bonham Junior High", games: "4:30, 5:00, 5:30, 6:30", home: false },
    { date: "Jan 29", opponent: "Gunter", site: "Gunter", games: "4:30, 5:00, 5:30, 6:30", home: false },
    { date: "Feb 5", opponent: "Howe", site: "Pottsboro Middle School", games: "4:30, 5:00, 5:30, 6:30", home: true },
    { date: "Feb 12", opponent: "S & S", site: "S&S Middle School", games: "4:30, 5:00, 5:30, 6:30", home: false },
    { date: "Feb 14", opponent: "District Tournament", site: "S & S", games: "TBD", home: false },
  ];

  // Google Maps + Calendar Links
  const getMapLink = (location) =>
    `https://www.google.com/maps/search/${encodeURIComponent(location + " High School")}`;

  const getCalendarLink = (game) => {
    const title = `${game.opponent} vs Pottsboro JH Basketball`;
    const location = `${game.site} High School`;
    const details = `Pottsboro JH Basketball game vs ${game.opponent}. Game times: ${game.games}`;
    const startDate = "20251101T230000Z"; // Placeholder start time
    const endDate = "20251102T010000Z"; // Placeholder end time

    return `https://www.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(
      title
    )}&details=${encodeURIComponent(details)}&location=${encodeURIComponent(
      location
    )}&dates=${startDate}/${endDate}`;
  };

  return (
    <div className="jh-wrapper">
      {/* Header Section */}
      <header className="jh-header">
        <h1 className="jh-title">2025–2026 Junior High Basketball Schedule</h1>
        <div className="jh-subtitle">Pottsboro Cardinals</div>
      </header>

      {/* Schedule Grid */}
      <div className="jh-grid">
        {schedule.map((game, index) => (
          <div key={index} className={`jh-card ${game.home ? "jh-home" : "jh-away"}`}>
            <div className="jh-card-header">
              <img src={PottsboroLogo} alt="Team logo" className="jh-logo" />
              <div className="jh-card-info">
                <h2 className="jh-opponent">{game.opponent}</h2>
                <p className="jh-date">{game.date}</p>
              </div>
            </div>

            <div className="jh-details">
              <p><strong>Site:</strong> {game.site}</p>
              <p><strong>Game Times:</strong> {game.games}</p>
            </div>

            <div className="jh-actions">
              <a href={getMapLink(game.site)} target="_blank" rel="noopener noreferrer" className="jh-btn jh-map-btn">
                🗺️ Directions
              </a>
              <a href={getCalendarLink(game)} target="_blank" rel="noopener noreferrer" className="jh-btn jh-calendar-btn">
                📅 Add to Calendar
              </a>
            </div>
          </div>
        ))}
      </div>

      {/* Photos Placeholder */}
      <section className="jh-photos-section">
        <h2>Team Photos</h2>
        <p>Team photos will be added soon!</p>
      </section>
    </div>
  );
}
